// extracted by mini-css-extract-plugin
export default {"topHandle":"styles_topHandle__HM+Xs","bottomHandle":"styles_bottomHandle__5REpy"};